import type { Routes } from '@angular/router';
import { canActivate } from '@services/foerch-auth.guard';

export const APP_ROUTES: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./login/foerch-login.component').then(
        c => c.FoerchLoginComponent
      ),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./gsm/foerch-gsm-dashboard.component').then(
        c => c.FoerchGsmDashboardComponent
      ),
    canActivate: [canActivate],
  },
];
